export const ETAT_PLANIFIE = 'Planifie';
export const ETAT_EN_COURS = 'EnCours';
export const ETAT_REALISE = 'Realise';
export const ETAT_CLOTURER = 'Clos';

export const LIST_ETAT_AUDIT = [
  { code: ETAT_PLANIFIE, libelle: 'listeAudit.etat.planifie' },
  { code: ETAT_EN_COURS, libelle: 'listeAudit.etat.enCours' },
  { code: ETAT_REALISE, libelle: 'listeAudit.etat.realise' },
  { code: ETAT_CLOTURER, libelle: 'listeAudit.etat.clos' },
];

export const EXPORT_EXCEL_AUDIT_TECHNIQUE = 'audittechnique';
